import { Injectable } from '@angular/core';

import { StatsigService } from '@services/statsig.service';

// define an enum if feature gate key is used anywhere else in the app
export enum ENTERPRISE_PRODUCTIVITY_FEATURE_FLAGS {
  EP_GLOBAL_TIMEZONES_ENABLED = 'ep-global-timezones-enabled',
  EP_GLOBAL_COUNTRY_CODES_ENABLED = 'ep-global-country-codes-enabled',
  FE_EP_GROUP_SORTING_ENABLED = 'fe-ep-group-sorting-enabled',
  EP_NEW_ALERT_CREATION_ENABLED = 'ep-new-alert-creation-enabled',
}

@Injectable({ providedIn: 'root' })
export class EnterpriseProductivityFeatureFlagService {

  constructor(private statsigService: StatsigService) { }

  public isGlobalTimezonesEnabled(): boolean {
    return this.statsigService
      .evaluateGate(ENTERPRISE_PRODUCTIVITY_FEATURE_FLAGS.EP_GLOBAL_TIMEZONES_ENABLED);
  }

  public isGlobalCountryCodesEnabled(): boolean {
    return this.statsigService
      .evaluateGate(ENTERPRISE_PRODUCTIVITY_FEATURE_FLAGS.EP_GLOBAL_COUNTRY_CODES_ENABLED);
  }

  public isNewAlertCreationEnabled(): boolean {
    return this.statsigService
      .evaluateGate(ENTERPRISE_PRODUCTIVITY_FEATURE_FLAGS.EP_NEW_ALERT_CREATION_ENABLED);
  }
}
